import { Schemas } from "../_app/api/types";

export type AuthConfig = Schemas["CustomerPortalAuthConfigDto"];

export const SUCCESS = "SUCCESS";
export const ERROR = "ERROR";
export type VerifyTotpResponse = typeof SUCCESS | typeof ERROR;

export interface PasswordPolicy {
  minimumLength: number;
  requireLowercase: boolean;
  requireNumbers: boolean;
  requireSymbols: boolean;
  requireUppercase: boolean;
  temporaryPasswordValidityDays: number;
}

export type ChangePasswordForm = {
  password: string;
  confirmPassword: string;
};

export interface UserProfile {
  firstName?: string;
  lastName?: string;
  username?: string;
  email?: string;
}

export interface UserAuthSession {
  accessToken: string;
  idToken: string;
  userSub: string;
  userProfile: UserProfile;
  expiresAt?: number;
  act: boolean;
}
